import React, {useEffect, useState} from "react";
import {Button, Col, Form, Row} from "react-bootstrap";
import {FormLabelRequiredAsterisk} from "Components/Form/FormLabelRequiredAsterisk";

interface Props {
    onSave: (formData: {id: string; bic: string; bank: string}) => void;
    data?: {id: string; bic: string; bank: string};
    isEdit?: boolean;
}

export const AdminBankSwiftCodeForm: React.FC<Props> = (props) => {

    const [formData, setFormData] = useState({
        id: props.data?.id ?? '',
        bic: props.data?.bic ?? '',
        bank: props.data?.bank ?? '',
    });
    const [formErrors, setFormErrors] = useState({id: false, bic: false, bank: false});
    const [submited, setSubmited] = useState(false);

    const validate = (): boolean => {
        const errors = {
            id: !props.isEdit && !formData.id,
            bic: !formData.bic,
            bank: !formData.bank,
        };
        setFormErrors(errors);
        return !Object.values(errors).some(Boolean);
    };

    const save = () => {
        if (!submited) setSubmited(true);
        if (!validate()) return;
        props.onSave(formData);
    };

    useEffect(() => {
        setFormData({
            id: props.data?.id ?? '',
            bic: props.data?.bic ?? '',
            bank: props.data?.bank ?? '',
        });
    }, [props.data]);

    useEffect(() => {
        if (submited) validate();
    }, [formData]);

    return (
        <>
            <Row className={"row mt-4"}>
                <Col xs={12} sm={4}>
                    <Form.Group controlId={"id"}>
                        <Form.Label>
                            Código banco
                            {!props.isEdit && <>&nbsp;<FormLabelRequiredAsterisk/></>}
                        </Form.Label>
                        <Form.Control
                            type="text"
                            onChange={(e) => setFormData({...formData, id: e.target.value})}
                            value={formData.id}
                            readOnly={props.isEdit}
                            disabled={props.isEdit}
                            className={formErrors.id ? 'is-invalid' : ''}
                        />
                        {formErrors.id && <p className={"text-danger pt-2"}>El campo es obligatorio</p>}
                    </Form.Group>
                </Col>
                <Col xs={12} sm={4}>
                    <Form.Group controlId={"bic"}>
                        <Form.Label>
                            BIC / SWIFT
                            &nbsp;<FormLabelRequiredAsterisk/>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Ej: POPLESMMXXX"
                            onChange={(e) => setFormData({...formData, bic: e.target.value})}
                            value={formData.bic}
                            className={formErrors.bic ? 'is-invalid' : ''}
                        />
                        {formErrors.bic && <p className={"text-danger pt-2"}>El campo es obligatorio</p>}
                    </Form.Group>
                </Col>
                <Col xs={12} sm={4}>
                    <Form.Group controlId={"bank"}>
                        <Form.Label>
                            Banco
                            &nbsp;<FormLabelRequiredAsterisk/>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            onChange={(e) => setFormData({...formData, bank: e.target.value})}
                            value={formData.bank}
                            className={formErrors.bank ? 'is-invalid' : ''}
                        />
                        {formErrors.bank && <p className={"text-danger pt-2"}>El campo es obligatorio</p>}
                    </Form.Group>
                </Col>
            </Row>

            <Row style={{"paddingTop": "50px"}}>
                <Col xs={12} sm={4}>
                    <Button className={"purple-btn btn-sm mt-4"} onClick={save}>
                        Guardar
                    </Button>
                </Col>
            </Row>
        </>
    );
};
